module.exports = __webpack_public_path__ + "static/media/scriber.34c6d4c5.png";